import { ThemeProvider } from '@mui/material';
import React, { useMemo } from 'react';

import type { Theme } from '../../themes/themes';

interface HeaderProps {
  id?: string;
  createTheme: () => Theme;
  children: React.ReactNode;
}

export const Header: React.FC<HeaderProps> = ({ children, createTheme }: HeaderProps) => {
  const headerTheme = useMemo(createTheme, [createTheme]);

  return <ThemeProvider theme={headerTheme}>{children}</ThemeProvider>;
};
